import { useQuery } from "@tanstack/react-query";
import { getAvailableProductCount } from "@/lib/product-count.functions";

/** Πλήθος διαθέσιμων προϊόντων, μορφοποιημένο (π.χ. "21.345"). */
export function useProductCountLabel(): string {
  const { data } = useQuery({
    queryKey: ["available-product-count"],
    queryFn: () => getAvailableProductCount(),
    staleTime: 6 * 60 * 60 * 1000,
  });
  const n = data?.count;
  return n ? n.toLocaleString("el-GR") : "20.000+";
}
